import { Collapse } from 'reactstrap';
import cls from 'classnames';
import { capitalize } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { Block } from '../../Block';
import './index.scss';

export const InfoCheckbox = ({
    className,
    id: fieldId,
    name,
    checked,
    onChange,
    disabled,
    label,
    children,
    tooltip,
    badge: Badge,
    formGroupClassName = '',
    color = 'primary',
}) => {
    const id = fieldId || name;

    return (
        <div
            className={cls('form-group', formGroupClassName)}
        >
            <label
                htmlFor={`${id}-checkbox`}
                disabled={disabled}
                className={cls(
                    'info-checkbox mb-0',
                    className,
                    checked && 'checked',
                    `color${capitalize(color)}`,
                    Boolean(children) && 'children',
                    disabled && 'disabled',
                )}
            >
                <div>
                    <input
                        id={`${id}-checkbox`}
                        name={name}
                        checked={checked}
                        type="checkbox"
                        onChange={onChange}
                        disabled={disabled}
                    />

                    {checked ? <FontAwesomeIcon icon={faSquareCheck} /> : <FontAwesomeIcon icon={faSquare} />}

                    {label}
                </div>

                {Boolean(tooltip) && (
                    <div>
                        {tooltip}
                    </div>
                )}

                {Boolean(Badge) && <Badge />}
            </label>

            {Boolean(children) && (
                <Collapse isOpen={checked}>
                    <Block
                        padding="medium"
                    >
                        {children}
                    </Block>
                </Collapse>
            )}
        </div>
    );
};